export default [
  {
    path: "/rapormusterigecici",
    name: "rapormusterigecici",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "rapormusterigecici.Baslik",
      yetki: { k: [2001102] },
    },
  },
]
